#import "./inbox-user-fragment.graphql"
#import "./inbox-related-lead-fragment.graphql"

fragment InboxThreadFragment on Thread {
    id
    isOpen
    isActive
    effectiveStatus
    threadSummary
    canArchive
    canReopen
    isAssignedToCurrentUser
    botStatus
    displayMessage {
        id
        isOutbound
        content
        sentTime
        failedTime
        scheduledTime
        images
    }
    creatorUser {
        ...InboxUserFragment
    }
    createdTime
    snoozedUntilTime
    closedTime
    owner {
        ... on User {
            ...InboxUserFragment
        }
        ... on Team {
            id
            name
        }
    }
    externalChannel {
        id
        type
        sessionId
        status
        phone {
            id
            numberFormatted
            numberFormattedWithCountryCode
        }
        email {
            address
        }
    }
    bestEntity {
        id
        name
        avatarUrl
        htmlUrlPath
        ... on Contact {
            initials
            accounts {
                primary {
                    id
                    name
                }
            }
        }
        ... on Account {
            initials
        }
    }
    stubEntity {
        id
        name
        avatarUrl
        htmlUrlPath
        initials
    }
    relatedLeads {
        ...InboxRelatedLeadFragment
    }
    threadType
    isUnread
}
